export default __webpack_public_path__ + "static/media/Minicard_Th.01cc0dea.svg";